import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchIsPhoneRegistered } from '../../repositories/users/v1/is-phone-registered';
import { ECheckPhoneStatus } from './types';
export function isPhoneRegistered(_x, _x2) {
  return _isPhoneRegistered.apply(this, arguments);
}
function _isPhoneRegistered() {
  _isPhoneRegistered = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dependencies, parameters) {
    var httpApi, logger, isPhoneRegisteredResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          httpApi = dependencies.httpApi, logger = dependencies.logger;
          _context.prev = 1;
          _context.next = 4;
          return fetchIsPhoneRegistered({
            httpApi: httpApi,
            parameters: parameters
          });
        case 4:
          isPhoneRegisteredResponse = _context.sent;
          if (!(isPhoneRegisteredResponse.statusCode === 400)) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", {
            status: ECheckPhoneStatus.Failed,
            message: isPhoneRegisteredResponse.response.message
          });
        case 7:
          return _context.abrupt("return", {
            status: ECheckPhoneStatus.Succeed,
            isRegistered: !!isPhoneRegisteredResponse.response.isRegistered
          });
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](1);
          logger.error(_context.t0, {
            domain: 'auth-widget.api.isPhoneRegistered'
          });
          return _context.abrupt("return", {
            status: ECheckPhoneStatus.Failed,
            message: 'Произошла непредвиденная ошибка'
          });
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 10]]);
  }));
  return _isPhoneRegistered.apply(this, arguments);
}